import Vue from 'vue'
import configs from '@/config'

let resource = null

const actions = {
  startSelfPacedAttempt: {
    method: 'POST',
    url: `${configs.baseUrl}/api/presentation/{presentationId}/self-paced-attempts`,
  },
}

const initResource = () => {
  resource = Vue.resource('', {}, actions)
}

const startSelfPacedAttempt = async ({ presentationId, participantId }) => {
  const res = await resource.startSelfPacedAttempt({ presentationId }, { participantId })
  return res.body
}

export default {
  initResource,
  startSelfPacedAttempt,
}
